(() => {
  const LANDING_KEY = 'rf_enquiry_landing_url';

  const safeGet = (key) => {
    try {
      return window.sessionStorage.getItem(key) || '';
    } catch (_) {
      return '';
    }
  };

  const safeSet = (key, value) => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (_) {
      // Ignore storage failures; the form still works normally.
    }
  };

  const currentUrl = window.location.href;

  if (!safeGet(LANDING_KEY)) {
    safeSet(LANDING_KEY, currentUrl);
  }

  const ensureHiddenField = (form, name, value) => {
    let input = form.querySelector(`input[type="hidden"][name="${name}"]`);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value || '';
  };

  const isEnquiryForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return false;

    const action = form.getAttribute('action') || '';
    const hasContactField = form.querySelector('[name^="contact["]');

    return action.includes('/contact') && Boolean(hasContactField);
  };

  const populateForm = (form) => {
    if (!isEnquiryForm(form)) return;

    ensureHiddenField(form, 'contact[Landing URL]', safeGet(LANDING_KEY) || currentUrl);
  };

  const populateAllForms = () => {
    document.querySelectorAll('form').forEach(populateForm);
  };

  document.addEventListener('submit', (event) => {
    populateForm(event.target);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', populateAllForms, { once: true });
  } else {
    populateAllForms();
  }
})();
